module.exports = __webpack_public_path__ + "frxxyy/img/loop.mp4?07f6cba1";